// Human-reviewed workout illustrations only.
//
// Keys MUST be the exact output of normalizeExerciseName(). Do not add a
// movement until its artwork has been visually checked for the correct
// exercise, equipment, body position, and start/finish relationship.
//
// Example for a future approved asset:
//   "pull up": "/exercise-media/verified/pull_up.webp",
//
// The map intentionally starts empty. Existing Emergent-era SVGs and imported
// remote URLs stay in the repository for reference, but workout screens do not
// show them until an illustration is explicitly approved here.
export const verifiedExerciseMedia = Object.freeze({});
